import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Col, Menu, Row, Switch } from 'antd'
import { ImportOutlined, LockOutlined, LogoutOutlined } from '@ant-design/icons'
import {
  loginAsCompany,
  loginAsCustomer,
  logout,
  switchEventAutoImport,
} from '../../store/action/profile.action'
import util from '../../util/util'
import serviceInterface from '../../services/service.interface'
import { constants } from '../../constants'
import Session from '../../util/sessionstore'

const AvatarPopupMenu = (props) => {
  var verifyRoles = (roles = []) => {
    if (roles.length == 0) return true
    return serviceInterface.AuthService().authorize_role(roles, props.decoded)
  }

  const handleAutoChange = async (flag, event) => {
    var resp = await props.switchEventAutoImport(
      {
        customer: props.customer?._id,
        company: props.company?._id,
      },
      flag
    )
    if (!resp) return
    if (verifyRoles(constants.ROLE.ADMIN)) {
      var cus = JSON.parse(JSON.stringify(props?.customer))
      cus.autoimportevent = flag
      props.updateCustomer(cus)
      new Session().updateCustomer(cus)
    } else {
      var comp = JSON.parse(JSON.stringify(props?.company))
      comp.autoimportevent = flag
      props.updateCompany(comp)
      new Session().updateCompany(comp)
    }
  }

  const getValue = () => {
    if (verifyRoles(constants.ROLE.ADMIN)) {
      return props?.customer?.autoimportevent
    } else {
      return props?.company?.autoimportevent
    }
  }

  return (
    <Menu>
      <Menu.Item>
        <Link to='/resetpassword'>
          <LockOutlined /> Reset Password
        </Link>
      </Menu.Item>
      {/* {verifyRoles([constants.ROLE.ADMIN, constants.ROLE.COMPANY_ADMIN]) && <Menu.Divider />} */}
      <Menu.Item
        /*hidden={!verifyRoles([constants.ROLE.ADMIN, constants.ROLE.COMPANY_ADMIN])}*/ hidden
      >
        <Row wrap={false} gutter={20}>
          <Col>
            <a>
              <ImportOutlined /> Auto Import
            </a>
          </Col>
          <Col style={{ marginLeft: 'auto' }}>
            <Switch
              onChange={handleAutoChange}
              checked={getValue()}
              size='small'
            />
          </Col>
        </Row>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a onClick={() => props.logoutapp()}>
          <LogoutOutlined /> Logout
        </a>
      </Menu.Item>
    </Menu>
  )
}

AvatarPopupMenu.propTypes = {
  logoutapp: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    decoded: util.verifyToken(state.profile.token, true),
    customer: state.profile.customer,
    company: state.profile.company,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logoutapp: () => dispatch(logout()),
    switchEventAutoImport: (params, flag) =>
      dispatch(switchEventAutoImport(params, flag)),
    updateCompany: (comp) => dispatch(loginAsCompany(comp)),
    updateCustomer: (comp) => dispatch(loginAsCustomer(comp)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AvatarPopupMenu)
